import { JSXElementConstructor, ReactElement, ReactNode, useEffect, useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { borderBottom } from "@mui/system";

let serverUrl = window.location.origin;

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
  }));

export interface VariantRewardProps {
    data: any,
    num: number,
    showEmpty:boolean
    dragAndDropIconProps?: any
    //delete: () => Promise<boolean>
}

export default function VariantReward(props: VariantRewardProps) {
    const [expanded, setExpanded] = useState(false);
    const [showArrow, setShowArrow] = useState(false);

    const handleChange = () => () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        // Check if any data is available
        if(props.data.summary !== "" || props.data.image !== "" || props.data.url !== "" || props.showEmpty){
            setShowArrow(true);
        }
    }, []);
    
    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"credential_info_" + props.num + "_"+ props.data.title}
            sx={{ borderBottom: "2px solid rgba(0, 0, 0, 0.03) !important", width: "100%" , backgroundColor:"gainsboro" ,marginBottom:"15px !important",textOverflow: "ellipsis", overflow: "hidden" }}
            id={"credential_info_" + props.num + "_"+ props.data.title}
        >
            <MuiAccordionSummary
                expandIcon={ showArrow && <ExpandMoreIcon />}
                sx={{ minHeight: "38px",textOverflow: "ellipsis", overflow: "hidden" }}
                >
             {props.dragAndDropIconProps && <div {...props.dragAndDropIconProps} style={{minWidth:"10px", height:"16px",paddingRight:"10px",margin:"auto 0"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"/></svg>
                </div>}
             
                <Typography sx={{ fontSize: "16px", fontWeight: "550",textOverflow: "ellipsis", overflow: "hidden" }}>
                    {props.data.title}
                </Typography>

              
            </MuiAccordionSummary>

            {/* login view */}
            {props.showEmpty &&  <>
                <AccordionDetails  
                sx={{ backgroundColor:"white"}}>
                    <div className="product-details"> 
                        <h2 className="sub-title">AWARD SUMMARY: </h2> 
                        {props.data.summary !== "" ? <p>{props.data.summary}</p>: <span>{props.showEmpty ? "N/A" : ""}</span> }
                        <h2></h2> 
                        {props.data.image !== "" ?<img src={props.data.image} alt={props.data.title} height="auto" width="30%"/>: <span>No award image</span> }
                        <br/>
                        {props.data.url !== "" ? <a href={props.data.url}  target="_blank">See award link</a>: <span>See award link: N/A</span> }
                    </div>
                    
                </AccordionDetails>
            </>}

            {/* logout view */}
            {showArrow && !props.showEmpty &&  <>
                <AccordionDetails  
                sx={{ backgroundColor:"white"}}>
                    <div className="product-details"> 
                        {props.data.summary !== "" ?  <>
                            <h2 className="sub-title">AWARD SUMMARY: </h2>
                            <p>{props.data.summary}</p> 
                        </> : <></> }
                        <h2></h2> 
                        {props.data.image !== "" ? <img src={props.data.image} alt={props.data.title} height="auto" width="30%"/>:  <></> }
                        <br></br>
                        {props.data.url !== "" ? <a href={props.data.url} target="_blank">See award link</a>:  <></> }
                    </div>
                    
                </AccordionDetails>
            </>}
        </Accordion>
    )
}